module.exports = __webpack_public_path__ + "img/discussion-forum.67008072.svg";